import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  AnimateSharedLayout,
  motion,
  useTransform,
  useViewportScroll,
} from "framer-motion";

// -- Components --
import HeroSec from "./Components/HeroSec";
import ProjectSec from "./Components/ProjectSec";
import SkillSec from "./Components/SkillSec";
import ContactSec from "./Components/ContactSec";

function App() {
  // const [scrollValue, setScrollValue] = useState(0);
  const { scrollY } = useViewportScroll();
  const vHeight = window.innerHeight;

  const background = useTransform(
    scrollY,
    [0, vHeight, vHeight * 2 - 100, vHeight * 2 + vHeight / 2],
    ["#fffff", "#e3e3e3", "#262626", "#000000"],
    { clamp: false }
  );

  // useEffect(() => {
  //   scrollY.onChange((e) => {
  //     const value = Math.floor(scrollY.get());
  //     setScrollValue(value);
  //   });
  // }, [scrollY]);
  return (
    <AnimateSharedLayout>
      <motion.div style={{ background: background }}>
        <HeroSec />
        <ProjectSec />
        <SkillSec />
        <ContactSec />
      </motion.div>
    </AnimateSharedLayout>
  );
}

// <motion.h1 className="location">{scrollValue}</motion.h1>
export default App;
